<template>
  <div
      :class="'notifications-sky-wrapper '+((is_active == true) ? 'is-active' : 'is-not-active')+' alert-'+type+' '+((is_active == true) ? 'active' : '' )"
      v-if="last_bell">

        <span class="foreground">
            <!-- <span class="bell">🔔</span> -->

                <span class="message-display">
                    <span class="" v-if="is_active == true || seconds_ago < 90">
                        <span class="pulsing-fx" v-if="is_active == true">My <CompanyName class="app-name"
                                                                                          :app=last_bell.app_name></CompanyName> bell<span class="br"></span> is ringing for you</span>
                        <span class="" v-if="is_active != true && seconds_ago < 90">My <CompanyName class="app-name"
                                                                                                    :app=last_bell.app_name></CompanyName> bell<span class="br"></span> just rang for you</span>
                    </span>
                    <span v-else>
                        A <strong><CompanyName class="app-name"
                                               :app=last_bell.app_name></CompanyName></strong> bell <span
                        class="br"></span> <span v-if="time_ago">quietly rung for you
                      <!--{{ time_ago | moment("from", "now", true) }} ago--></span>
                    </span>
                  <div class="message-detail">
                    🔔 <AppName class="app-name"
                                :app=last_bell.app_name></AppName>| <span v-if="seconds_ago < 60">less than </span>{{ time_ago | moment("from", "now", true) }} ago
                  </div>


                </span>

        </span>

  </div>
</template>

<style lang="scss">

$statement_size: 7vh;


.notifications-sky-wrapper {
  background: #5079B1;

  $circle_radius: 50vh;

  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  z-index: 10;
  mix-blend-mode: difference;
  box-sizing: border-box;


  transition: background-color 1s ease-in-out;

  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;

  font-size: $statement_size;
  font-size: 8vh;

  @media (orientation: landscape) {
    @media (max-width: 1140px) {
      font-size: 6vh;
    }
  }

  @media (orientation: portrait) {
    font-size: 5vh;
    @media (max-width: 900px) {
      .br {
        display: block;
      }
    }

  }

  padding: 1rem;

  &:before {
    content: "";
    position: fixed;
    display: block;
    width: $circle_radius;
    height: $circle_radius;
    border-radius: 100%;
    background: rgba(0, 0, 0, .25);
    top: calc((100vh - #{$circle_radius}) / 2);
    left: calc((100% - #{$circle_radius}) / 2);
    opacity: 0;
    z-index: 1;


  }

  &:after {
    content: "";
    position: fixed;
    display: block;
    background-color: rgba(0, 0, 0, .75);
    z-index: 2;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    /*transition: opacity .35s ease;*/
  }

  &.is-active:after {
    opacity: 1;
  }


  .bell {

    /* position: relative;
     top: 2px*/

    font-size: $statement_size;
    display: block;
    margin-bottom: .5rem;


  }

  &.active {

    &:after {

      transform: scale(500);
      background: rgba(0, 0, 0, .15);
      animation: pulsate 3s ease-out;
      animation-iteration-count: 1;
    }


    .bell {

      animation: bellshake .5s cubic-bezier(.36, .07, .19, .97) both;
      animation-iteration-count: infinite;
      backface-visibility: hidden;
      transform-origin: top right;

      @keyframes bellshake {
        0% {
          transform: rotate(0);
        }
        15% {
          transform: rotate(5deg);
        }
        30% {
          transform: rotate(-5deg);
        }
        45% {
          transform: rotate(4deg);
        }
        60% {
          transform: rotate(-4deg);
        }
        75% {
          transform: rotate(2deg);
        }
        85% {
          transform: rotate(-2deg);
        }
        92% {
          transform: rotate(1deg);
        }
        100% {
          transform: rotate(0);
        }
      }

    }

  }


}


.alert-aggiornamenti-software {
  background-color: olive;
}

.alert-google {
  background-color: blue;
}

.alert-gmail {
  background-color: red;
}

.alert-whatsapp {
  background-color: #25d366;
}

.alert-tim-telefono {
  background-color: #ff0000;
}

.alert-messaggi {
  background-color: gray;
}

.alert-meteo {
  background-color: orange;
}

.alert-facebook {
  background-color: #3b5998;
}

.alert-banca-mps {
  background-color: #800;
}

.alert-linkedin {
  background-color: #0e76a8;
}

.alert-google-play-services {
  background-color: #ffd400;
}

.alert-galaxy-themes {
  background-color: green;
}

.alert-chrome {
  background-color: orangered;
}

.alert-instagram {
  background-color: #833AB4;
}

.alert-wish {
  background-color: #00aaee;
}

.alert-spotify {
  background-color: #1DB954;
}

.alert-impostaz-utente {
  background-color: lightgray;
}

.alert-acquisizione-samsung {
  background-color: fuchsia;
}

.alert-youtube {
  background-color: #FF0000;
}


.alert-note-di-keep {
  background-color: #F4B400;
}

.alert-hangouts, .alert-hangout {
  background-color: #34a853;
}

.alert-telegram {
  background-color: #28a8e8;
}


.message-display {
  margin-left: .35rem;
  font-style: italic;
}

.message-detail {
  font-size: 21px;
  /*font-style: normal;*/
  @media screen and (max-width: 768px) {
    font-size: 16px;
    margin-top: .5rem;

  }

}


.app-name {
  /*font-weight: bold;*/
  position: relative;
}

.pulsing-fx {
  animation: flashing .75s cubic-bezier(.36, .07, .19, .97);
  animation-iteration-count: infinite;

}

@keyframes flashing {
  0% {
    opacity: 1.0;
  }
  50% {
    opacity: 0.0;
  }
  100% {
    opacity: 1.0;
  }
}


.foreground {
  position: relative;
  z-index: 100;
  text-align: left;

  @media screen and (max-width: 768px) {
    text-align: center;

  }

}


@keyframes pulsate {
  0% {
    transform: scale(.1, .1);
    opacity: 0.0;
  }
  30% {
    opacity: 1.0;
  }
  90% {
    opacity: 0;
  }
  100% {
    transform: scale(25, 25);
    opacity: 0.0;
  }
}

#notification-bells {
  font-size: 36px;

  small {
    font-size: 18px
  }

  .notification-text {
    opacity: 0;

    transition: all .25s ease;

    &.status-display {
      opacity: 1;
      transition: all .75s ease;
    }

    &.status-hiding {
      opacity: 0;
    }
  }


}


@media screen and (orientation: portrait) and (max-width: 480px) {

  .notifications-sky-wrapper {

    flex-direction: column;

    .bell {
      font-size: 32px;
      display: block;
      margin-bottom: 1rem;
    }


  }

}

</style>

<script>
import axios from "axios";
import moment from "moment";
import SingleBell from "./SingleBell";
import AppName from "./AppName";

import Pizzicato from 'pizzicato';
import CompanyName from "@/components/CompanyName";

var reverb = new Pizzicato.Effects.Reverb({
  time: 10,
  decay: 3,
  reverse: false,
  mix: 0.75
});

var flanger = new Pizzicato.Effects.Flanger({
  time: 0.45,
  speed: 0.2,
  depth: 0.1,
  feedback: 0.1,
  mix: 0.25
});

var lowPassFilter = new Pizzicato.Effects.LowPassFilter({
  frequency: 2500,
  peak: 12
});

var Bell = new Pizzicato.Sound({
  source: 'file',
  options: {
    path: '/media/bell.mp3'
  }
});
Bell.addEffect(reverb);
Bell.addEffect(flanger);


function Channel(audio_uri) {
  this.audio_uri = audio_uri;
  this.resource = new Audio('/media/bell.mp3');
  //this.resource.playbackRate = .1;

  //this.resource = Bell
  //this.resource.attack = 0.1;

}

Channel.prototype.play = function () {
  // Try refreshing the resource altogether
  this.resource.play();
}

function Switcher(audio_uri, num) {
  this.channels = [];
  this.num = num;
  this.index = 0;

  for (var i = 0; i < num; i++) {
    this.channels.push(new Channel(audio_uri));
  }
}

Switcher.prototype.play = function () {
  this.channels[this.index++].play();
  this.index = this.index < this.num ? this.index : 0;
}


export default {
  name: "NotificationToSound",
  components: {
    SingleBell,
    AppName,
    CompanyName
  },
  data() {
    return {
      page: 0,

      sound_ready: false,

      clearId: null,
      is_active: false,

      bells: {},

      colors: [
        "#25d366", //WHATSAPP

        ""
      ],
      first_time_load: true,
      time_ago: null

    };
  },

  props: {},

  async created() {

    this.first_time_load = true;
    this.updateBells();

    this.bell = new Switcher('/media/bell.mp3', 10);

    setInterval(() => {

      this.time_ago = null;
      this.time_ago = (this.last_bell && this.last_bell.received_at) ? this.last_bell.received_at : null;


    }, 10000)

    setTimeout(() => {
      this.ringBell(false);
    }, 250)

    console.log("Created... end");

  },

  sockets: {
    connect: function () {
    },

    ItsRingingForYou: function (data) {
      var notification = this.clean_notification(data.params);

      //this.$emit("notification", notification);

      this.$set(this.bells, notification.id, notification);

      setTimeout(() => {
        this.bells[notification.id].status = 'hiding'
        setTimeout(() => {
          this.bells[notification.id].status = 'hidden'
        }, 1000);

      }, 4000)


    }
  },


  methods: {

    ringBell(visualFix) {

      if (visualFix != false) this.is_active = true;

      this.bell.play();

      setTimeout(() => {

        if (visualFix != false) this.is_active = false;

      }, 7500)

    },

    addMockupData() {
      var notification = this.clean_notification({
        received_at:
            moment().format("MMMM DD, YYYY") + " at " + moment().format("hh:mmA"),
        //" June 20, 2020 at 11:21AM",
        app_name: " Chrome",
        " notification_message":
            "momentjs.com - Inviato da MacBook-Pro-di-Clemente"
      });

      this.$emit("notification", notification);
      this.$set(this.bells, notification.id, notification);


    },

    clean_notification(data) {


      var cleaned_item = {
        id: Object.keys(this.bells).length + 1,
        app_name: data.app_name.trim(),
        //notification_message: data[" notification_message"].trim(),
        received_at: moment(
            data.received_at
                .replace(" at ", " ")
                .replace("AM", " AM")
                .replace("PM", " PM")
                .trim()
        ),
        status: 'display'
      }

      if (data[" notification_message"]) {

        cleaned_item["notification_message"] = data[" notification_message"].trim();

      }


      return cleaned_item;
    },

    async updateBells() {

      try {
        var response = await axios.get(
            process.env.VUE_APP_WEBSOCKET_SERVER + process.env.VUE_APP_API_BASE_URL + "/archive/" + this.archive_date
        );

        response.data.forEach(single => {

          var notification = this.clean_notification(single);
          this.$set(this.bells, notification.id, notification);

          /*this.$emit("notification", notification);

          setTimeout(() => {
            this.bells[notification.id].status = 'hiding'
            setTimeout(() => {
              this.bells[notification.id].status = 'hidden'
            },1000);

          },4000)*/


        });

        // console.log("response", response);
        // if (response && response.data && response.data.news) {
        //   response.data.news.forEach(single => {
        //     // console.log(single);
        //     news.push({
        //       id: single.id,
        //       date: moment(single.date),
        //       title: single.title,
        //       text: single.text
        //     });
        //   });

        //   this.news.push({
        //     date: moment(response.data.news[0].date),
        //     bg: this.bg(),
        //     data: news
        //   });
        // }
        //console.log("response is", response.data, moment().subtract(this.page,'days').format("YYYY-MM-DD"), moment().subtract(this.page+1,'day').format("YYYYMMDD"))
      } catch (error) {
        if (error && error.response && error.response.status == 400)
          this.archiveEnded = true;
        //console.log("ERROR",error)
      }
    }
  },

  computed: {

    reversedBellKeys() {
      return Object.keys(this.bells).sort((a, b) => b - a);
    },

    last_bell() {
      if (this.reversedBellKeys && this.reversedBellKeys[0]) {
        return this.bells[this.reversedBellKeys[0]]
      } else {
        return null;
      }

    },

    seconds_ago() {

      if (!this.time_ago) {

      } else {

        var duration = moment.duration(moment().diff(moment(this.time_ago)));
        var seconds = duration.asSeconds();

        return seconds
      }

    },

    the_time_ago() {

      if (!this.time_ago) {

      } else {

        var duration = moment.duration(moment().diff(moment(this.time_ago)));
        var seconds = duration.asSeconds();


        return (seconds < 60) ? 'a moment' : moment(this.time_ago).fromNow(true);
      }

    },

    type() {
      if (this.last_bell) {
        return this.last_bell.app_name.toLowerCase().replace(/\ /gi, "-");
      } else {
        return null;
      }

    },

    archive_date() {
      return moment().subtract(this.page, 'days').format("YYYY-MM-DD");
    },

  },

  watch: {

    last_bell(v, o) {
      if (v != o && this.first_time_load != true) this.ringBell();

      this.time_ago = this.last_bell.received_at;
      this.first_time_load = false;

      //console.log("CHANGED?",v,o);
    }

  }

};
</script>